import { Grid, Typography, Button } from "@mui/material";
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import AmplifyAPIWrapper from "src/API/AmplifyAPIWrapper";
import { openSnackbar } from "src/redux/actions/App.Actions";
import { styled } from "@mui/system";

interface ICrewSnapshotProps {
  crewId: string;
}

const SnapButton = styled(Button)({
  padding: "0px 2px",
  fontSize: 11,
  height: 24,
});

const SnapTypography = styled(Typography)({
  fontSize: 14,
  fontWeight: "bolder",
  margin: "3px 35px 0px 0px",
});

export const CrewSnapshot = (props: ICrewSnapshotProps): JSX.Element => {
  const { crewId } = props;
  const dispatch = useDispatch();

  const takeSnapshot = useCallback(() => {
    const postSnapshot = async (): Promise<void> => {
      dispatch(
        openSnackbar({
          open: true,
          closeDelay: 3000,
          variant: "info",
          message: "Taking Snapshot",
        })
      );
      const snapshotResponse: any = await AmplifyAPIWrapper.Post(`/crewschedule/snapshot/save/${crewId}`, {});
      if (!snapshotResponse || typeof snapshotResponse === "undefined" || snapshotResponse?.result?.error) {
        dispatch(
          openSnackbar({
            open: true,
            closeDelay: 3000,
            variant: "error",
            message: "Unable to Save Snapshot",
          })
        );
      } else {
        dispatch(
          openSnackbar({
            open: true,
            closeDelay: 3000,
            variant: "success",
            message: "Snapshot Saved Successfully",
          })
        );
      }
    };
    postSnapshot();
  }, [crewId, dispatch]);

  return (
    <Grid container wrap="nowrap" sx={{ padding: "0px 10px 10px 15px" }}>
      <SnapTypography variant="body1">Crew Snapshot</SnapTypography>
      <SnapButton onClick={takeSnapshot} color="primary" variant="contained">
        TAKE
      </SnapButton>
    </Grid>
  );
};
